import React from "react";
import "./Loader.css";

function LoaderComponent() {
  return (
    <div className="loadWrapper">
      <div className="loader"></div>
    </div>
  );
}

export default LoaderComponent;
